import React, { createContext, useContext, useMemo } from 'react'
import { useGetDonor, useTokenRefresh } from '@/hooks'

const DonorContext = createContext(null)

export const DonorProvider = ({ children }) => {
  const { donor, setDonor, loadingDonor, getDonor } = useGetDonor()

  // Initialize token refresh - will start when user logs in, stop when user logs out
  useTokenRefresh(donor)

  const value = useMemo(() => {
    return { donor, setDonor, loadingDonor, getDonor }
  }, [donor, loadingDonor])

  return <DonorContext.Provider value={value}>{children}</DonorContext.Provider>
}

export const useDonorContext = () => {
  const ctx = useContext(DonorContext)
  if (!ctx) {
    throw new Error('useDonorContext must be used within a DonorProvider')
  }
  return ctx
}

export default DonorContext
